import axios from "./config";

/**
 * @function
 * @name getGeneralRecommendations
 * @description get general recommendations
 * 
 * */
 const getGeneralRecommendations = (procuringEntityPackageId) => {
    return axios.get(`/procuring_entities/${procuringEntityPackageId}/general_recommendations`);
};

/**
 * @function
 * @name getGeneralRecommendationsByReport
 * @description get general recommendations by report ID
 * 
 * */
const getGeneralRecommendationsByReport = (reportId) => {
    return axios.get(`/procuring_entity_reports/${reportId}/general_recommendations`);
};

/**
 * @function
 * @name getCSCGeneralRecommendations
 * @description get CSC general recommendations with date filters
 * 
 * */
const getCSCGeneralRecommendations = (councilId, startDate, endDate) => {
    const params = new URLSearchParams({
        council_id: councilId,
        report_start_date: startDate,
        report_end_date: endDate
    });
    return axios.get(`/general_recommendations?${params}`);
};

/**
 * @function
 * @name getPITGeneralRecommendations
 * @description get PIT general recommendations with date filters
 * 
 * */
const getPITGeneralRecommendations = (councilId, startDate, endDate) => {
    const params = new URLSearchParams({
        'filter[council_id]': councilId,
        'filter[report_start_date]': startDate,
        'filter[report_end_date]': endDate
    });
    return axios.get(`/pit-reports?${params}`);
};

/**
 * @function
 * @name getPCTGeneralRecommendations
 * @description get PCT general recommendations with date filters
 * 
 * */
const getPCTGeneralRecommendations = (councilId, startDate, endDate) => {
    const params = new URLSearchParams({
        'filter[council_id]': councilId,
        'filter[report_start_date]': startDate,
        'filter[report_end_date]': endDate
    });
    return axios.get(`/pct-reports?${params}`);
};

export default {
    getGeneralRecommendations,
    getGeneralRecommendationsByReport,
    getCSCGeneralRecommendations,
    getPITGeneralRecommendations,
    getPCTGeneralRecommendations
}